// extracted by mini-css-extract-plugin
export var container = "_5h-0";
export var disabled = "_5h-4";
export var fullWidth = "_5h-3";
export var lined = "_5h-1";
export var selected = "_5h-5";
export var tab = "_5h-2";